export const FormCreateDataEsgFormFuel = {
  id: null,
  type_equipment: null,
  type_equipment_touched: false,
  fuel: null,
  fuel_touched: false,
  volume: null,
  volume_touched: false,
  distance: null,
  distance_touched: false,
  duplicate: false,
  deleted: false,
  action: null,
  changed: false
};

export const FormCreateDataEsgFormElectric = {
  id: null,
  electric: null,
  electric_touched: false,
  unit: null,
  unit_touched: false,
  file: null,
  file_touched: false,
  total: null,
  total_touched: false,
  duplicate: false,
  deleted: false,
  action: null,
  changed: false,
};

export const FormCreateDataEsgFormRenewableEnergy = {
  id: null,
  type: null,
  type_touched: false,
  consume: null,
  consume_touched: false,
  duplicate: false,
  deleted: false,
  action: null,
  changed: false,
};

export const FormCreateDataEsgFormEquipment = {
  id: null,
  unit: null,
  unit_touched: false,
  type_equipment: null,
  equipment: null,
  equipment_touched: false,
  duplicate: false,
  deleted: false,
  action: null,
  changed: false,
};

export const FormCreateDataEsgFormWaterConsume = {
  water_consume: null,
  total_water_consume: null,
  deleted: false,
};

export const FormCreateDataEsgFormDisposalPurposes = {
  waste_disposal_purposes: null,
  total_waste_disposal_purposes: null,
  deleted: false,
};

export const FormCreateDataEsgFormWasteB3 = {
  waste_b3: null,
  total_waste_b3: null,
  processing_waste_b3: null,
  total_processing_waste_b3: null,
  deleted: false,
};

export const FormCreateDataEsgFormWasteNonB3 = {
  waste_non_b3: null,
  total_waste_non_b3: null,
  processing_waste_non_b3: null,
  total_processing_waste_non_b3: null,
  deleted: false,
};

export const typeEquipmentEnum = {
  BERGERAK: "BERGERAK",
  TIDAK_BERGERAK: "TIDAK BERGERAK",
};

export const typeWaterEnum = {
  KONSUMSI: "KONSUMSI",
  TUJUAN_PEMBUANGAN: "TUJUAN PEMBUANGAN",
};

export const typeWasteEnum = {
  B3: "B3",
  NON_B3: "NON B3",
};

export const FormGenerateFileValidity = {
  name: null,
  name_pjo: null,
  nik: null,
  position: null,
  ttd: null,
  ttd_pjo: null,
  address: null,
}

export const formatNumber = (input) => {
  if (!input) return "";

  let rawValue = input.replace(/[^0-9,]/g, ""); // Hanya angka dan koma

  // Jika diawali koma, jadikan "0,"
  if (rawValue.startsWith(",")) {
    rawValue = "0" + rawValue;
  }

  let parts = rawValue.split(",");
  let integerPart = parts[0];

  // Hapus leading zero, kecuali jika hanya '0'
  if (integerPart.length > 1 && integerPart.startsWith("0")) {
    integerPart = integerPart.replace(/^0+/, "");
    // Jika setelah hapus 0 jadi kosong, isi dengan 0
    if (integerPart === "") integerPart = "0";
  }

  // Format ribuan
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Format desimal
  const decimalPart =
    parts[1] !== undefined ? `,${parts[1].replace(/,/g, "")}` : "";

  return integerPart + decimalPart;
};

export const formatNumberOnly = (input) => {
  if (!input) return "";

  // Hanya izinkan angka
  let rawValue = input.replace(/[^0-9]/g, "");

  // Hapus leading zero, kecuali jika hanya "0"
  if (rawValue.length > 1 && rawValue.startsWith("0")) {
    rawValue = rawValue.replace(/^0+/, "");
    if (rawValue === "") rawValue = "0";
  }

  // Format angka ke ribuan dengan titik
  let formatted = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return formatted;
};

export const FormValidasiDataFuel = {
  month: [(v) => !!v || "Bulan tidak valid"],
  ob_production: [
    (v) =>
      !!v?.trim() ||
      "OB Production harus diisi, Jika tidak ada mohon diisi dengan angka 0.",
    (v) =>
      (v && v.length <= 200) ||
      "OB Production tidak boleh lebih dari 200 karakter",
    (v) =>
      !v?.endsWith(",") ||
      "OB Production tidak boleh berakhir dengan tanda koma.",
    (v) =>
      /^[0-9]{1,3}(\.[0-9]{3})*(,[0-9]+)?$/.test(v) ||
      "OB Production harus berupa angka dengan format ribuan menggunakan titik dan desimal menggunakan koma.",
  ],
  coal_production: [
    (v) =>
      !!v?.trim() ||
      "Coal Production harus diisi, Jika tidak ada mohon diisi dengan angka 0.",
    (v) =>
      (v && v.length <= 200) ||
      "Coal Production tidak boleh lebih dari 200 karakter.",
    (v) =>
      !v?.endsWith(",") || "Coal Production tidak boleh berakhir dengan koma.",
    (v) =>
      /^[0-9]{1,3}(\.[0-9]{3})*(,[0-9]+)?$/.test(v) ||
      "Coal Production harus menggunakan format ribuan dengan titik dan desimal dengan koma.",
  ],
  type_equipment: [(v) => !!v || "Jenis emisi harus diisi."],
  unit: [
    (v) => !!String(v || "").trim() || "Unit harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Unit tidak boleh berakhir dengan koma.",
  ],
  equipment: [(v) => !!v || "Peralatan harus diisi."],
  fuel: [(v) => !!v || "Jenis Bahan Bakar harus diisi."],
  volume: [
    (v) => !!String(v || "").trim() || "Volume/Liter harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Volume/Liter tidak boleh berakhir dengan koma.",
  ],
  distance: [
    (v) => !!String(v || "").trim() || "Distance harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Distance tidak boleh berakhir dengan koma.",
  ],
};

export const FormValidasiDataElectric = {
  electric: [(v) => !!v || "Elektrifikasi harus diisi."],
  unit: [
    (v) => !!String(v || "").trim() || "Unit harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Unit tidak boleh berakhir dengan koma.",
  ],
  file: [
    (v) => !!String(v || "").trim() || "File harus diisi.",
    (v) => {
      if (!v) return true;
      const allowedExt = /\.pdf$/i;
      return allowedExt.test(v.name || "") || "File harus berformat PDF.";
    },
    (v) => {
      if (!v) return true;
      const maxSize = 5 * 1024 * 1024; // 5MB
      return v.size <= maxSize || "Ukuran file maksimal 5 MB.";
    },
  ],
  total: [
    (v) => !!String(v || "").trim() || "Elektrifikasi harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Total elektrifikasi tidak boleh berakhir dengan koma.",
  ],
};

export const FormValidasiDataRenewableEnergy = {
  type: [(v) => !!v || "Tipe renewable harus diisi."],
  consume: [
    (v) => !!String(v || "").trim() || "Total konsumsi harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Total konsumsi energy tidak boleh berakhir dengan koma.",
  ],
};

export const FormValidasiDataEquipment = {
  unit: [(v) => !!String(v || "").trim() || "Unit harus diisi."],
  equipment: [(v) => !!v || "Peralatan harus diisi."],
};

export const FormValidasiDataComment = {
  message: [(v) => !!String(v || "").trim() || "Pesan harus diisi."],
};

export const FormValdasiDataRollback = {
  message: [(v) => !!String(v || "").trim() || "Catatan harus diisi."],
};

export const FormValidasiDataValidity = {
  name: [(v) => !!String(v || "").trim() || "Nama harus diisi."],
  name_pjo: [(v) => !!String(v || "").trim() || "Nama harus diisi."],
  nik: [(v) => !!String(v || "").trim() || "NIK harus diisi."],
  position: [(v) => !!String(v || "").trim() || "Jabatan harus diisi."],
  ttd: [
    (v) => !!String(v || "").trim() || "TTD harus diisi.",
    (v) => {
      if (!v) return true;
      const allowedExt = /\.(png|jpe?g)$/i;
      return allowedExt.test(v.name || "") || "File harus berformat PNG, JPEG.";
    },
    (v) => {
      if (!v) return true;
      const maxSize = 1 * 1024 * 1024; // 5MB
      return v.size <= maxSize || "Ukuran file maksimal 1 MB.";
    },
  ],
  address: [(v) => !!String(v || "").trim() || "Alamat harus diisi."],
};
